import React from 'react';
import { Stack, InputLabel, MenuItem } from '@compass/core';
import { FormControl, Select, SelectChangeEvent } from '@mui/material';
import { useStudentData } from '../contexts/StudentDataContext';

export const StudentFilterControls = () => {
    const { 
        filter, 
        updateFilter, 
        activeSchoolYear, 
        schoolYears 
    } = useStudentData();

    // Derived state pattern:
    // If filter is null, display the activeSchoolYear.
    // If filter is set, display the filter.
    // This allows us to avoid syncing state with useEffects.
    const displayedYear = filter.schoolYear ?? activeSchoolYear ?? '';

    const handleYearChange = (event: SelectChangeEvent<number | string>) => {
        updateFilter({ schoolYear: Number(event.target.value) });
    };

    // Don't render the dropdown until the backend has returned the active year
    if (schoolYears.length === 0) {
        return null;
    }

    return (
        <Stack direction="row" spacing="sm" sx={{ mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="student-school-year-label">School Year</InputLabel>
                <Select
                    labelId="student-school-year-label"
                    value={displayedYear}
                    label="School Year"
                    onChange={handleYearChange}
                >
                    {schoolYears.map(year => (
                        <MenuItem key={year} value={year}>
                            {`${year}-${year + 1}`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
};